import BenefitsChart from '../benefits_chart';

class SymplrBenefitsChart extends BenefitsChart {
  custom_pie_chart_options() {
    return {
      legend: {
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle'
      },
    };
  }
}

export default SymplrBenefitsChart;
